var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh01 = function SvgRefresh01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.60002C7.91309 4.60002 4.6 7.91312 4.6 12C4.6 16.0869 7.91309 19.4 12 19.4C16.0869 19.4 19.4 16.0869 19.4 12H20.6C20.6 16.7497 16.7497 20.6 12 20.6C7.25035 20.6 3.4 16.7497 3.4 12C3.4 7.25038 7.25035 3.40002 12 3.40002C14.5687 3.40002 16.8749 4.52693 18.4498 6.31134L17.5502 7.10542C16.1933 5.56814 14.2101 4.60002 12 4.60002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8971 8.8H19.8V5.89706L16.8971 8.8ZM14 10L21 3V10H14Z"
  })));
};
export default SvgRefresh01;